import { Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { ToggleTalentPoolByDefaultDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  atsCompanyId: string
  talentPoolByDefault: boolean
}

const TalentPoolSettings = ({ atsCompanyId, talentPoolByDefault }: Props) => {
  const [toggle] = useMutation(ToggleTalentPoolByDefaultDocument, {
    extractorFn: (data) => data?.atsMutations.updateAtsCompany,
  })

  const onToggle = async (newValue: boolean) => {
    const result = await toggle({
      variables: {
        id: atsCompanyId,
        talentPoolByDefault: newValue,
      },
    })

    const handled = handleResult(result, (_errors) => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
  }
  return (
    <Section.TwoThirds
      description={i18n.t('app_store_v2.apps.ats.settings.talent_pool.description')}
      illustration="people-add"
      title={i18n.t('app_store_v2.apps.ats.settings.talent_pool.title')}
    >
      <Card>
        <Card.Title
          size="small"
          action={<TogglerCheckbox value={talentPoolByDefault} onChange={onToggle} />}
        >
          {i18n.t('app_store_v2.apps.ats.settings.talent_pool.toggle.title')}
        </Card.Title>
        <Card.Description>
          {i18n.t('app_store_v2.apps.ats.settings.talent_pool.toggle.description')}
        </Card.Description>
      </Card>{' '}
    </Section.TwoThirds>
  )
}

export default observer(TalentPoolSettings)
